angular.module('impactx.catalog').controller('InternalCatalogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$mdDialog',
    'ConfirmationService',
    '$redirect',
    'CatalogCheckinService',
    '$window',
    '$config',
    '$securityManager',
    'CatApprovalService',
    'TranslationService',
    'WarningService',
    'DefaultPicture',
    'ToastService',
    'CatalogActionsService',
    'ShopViewService',
    'ToolbarService',
    '$location',
    '$rootScope',
    InternalCatalogCtrl]);

function InternalCatalogCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $mdDialog, ConfirmationService,
                             $redirect, CatalogCheckinService, $window, $config, $securityManager, CatApprovalService,
                             TranslationService, WarningService, DefaultPicture, ToastService, CatalogActionsService,
                             ShopViewService, ToolbarService, $location, $rootScope) {
    var ctrl = this;
    $scope.tinymceOptions = $config.tinymceOptions;
    ctrl.errorList = [];

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    if (backButtonUsed && $rootScope.previousRoute && $rootScope.previousRoute.originalPath.indexOf("externalcatalog") > -1 &&
        $rootScope.previousRoute.params && $rootScope.previousRoute.params.id && $rootScope.previousRoute.params.id === $routeParams.id) {
        BackService.back();
        return;
    }
    ctrl.init = function () {
        dataGen.getData($scope, {id: $routeParams.id}, "/catalog/viewinternal").then(function () {
            ctrl.initToolbarButtons();
            $scope.initiated = true;
        });
    };
    ctrl.init();

    ctrl.redirectToCatList = function () {
        $redirect.redirectTo(null, "/cataloglist");
    };

    /**
     * Prepares data for saving.
     * @param data data to save
     * @return {*} simplified data to save
     */
    ctrl.prepareDataForSave = function (data) {
        var dataToSave = {};

        if (data) {
            dataToSave = angular.copy(data, dataToSave);

            dataToSave = dataGen.slimDown(dataToSave, {
                popups: ['approvalPopup', 'supplier', 'language', 'catalogTimeline'],
                relations: ['catalogManager', 'catalogManagerGroup', 'catalogPurchaser']
            });

            return dataToSave;
        }

        return data;
    };

    this.save = function () {
        if($scope.data.matchCodeSettings && $scope.data.matchCodeSettings.filter(function(item){
            return item.secondValue;
        }).length === 0){
            ConfirmationService.showConfirmationDialog(realSave, null, $scope.trns.matchcodeWarningHead,
                $scope.trns.save, $scope.trns.abort, $scope.trns.matchcodeWarningText);
        }
        else {
            return realSave();
        }
    };

    var realSave = function() {
        var dataObj = {
            cat: ctrl.prepareDataForSave($scope.data)
        };

        return dataGen.postAsForm($scope, dataObj, "/catalog/saveinternal").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.doneForward = function () {
        // CatalogActionsService.forwardToApproval($scope.data.id);
        CatApprovalService.forwardToApproval($scope.data.id, ctrl.redirectToCatList);
    };

    this.delete = function () {
        var dataObj = {
            catId: $scope.data.id
        };
        return dataGen.postAsForm($scope, dataObj, "/catalog/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };
    this.extendLastDate = function (event) {
        CatalogActionsService.extendLastDate(event, $scope.data, $scope.trns).then(function (result) {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                .textContent(result.trns.extendSuccess)
                .position("bottom right")
                .hideDelay(10000)
            );
        });
    };

    this.setFixDeliveryDate = function (event) {
        CatalogActionsService.setFixDeliveryDate(event, $scope.data, $scope.trns).then(function (result) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(result.trns.setFixDeliveryDateSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.removeLeasingCompanyProducts = function (index) {
        $scope.data.leasingCompanies[index].productsDeleted = true;
    };


    this.checkIn = function () {
        var scope = {};
        CatalogCheckinService.checkIn(scope, $scope.data.id).then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(scope.trns.checkInStarted)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            ctrl.redirectToCatalogList();
        })
    };

    this.deny = function () {
        CatalogActionsService.denyCheckedOut($scope.data.id, ctrl.redirectToCatList);
    };

    this.stop = function (event) {
        CatApprovalService.stopCatalog($scope.data.id, BackService.back, event);
    };

    this.checkout = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/catalog/checkout").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.checkoutSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.checkoutDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.checkout, event, $scope.trns.checkoutWarning, $scope.trns.checkoutNow, $scope.trns.abort, $scope.trns.checkoutQuestion);
    };

    this.review = function () {
        $redirect.redirectTo(null, '/checkedoutcataloglist/' + $scope.data.id);
    };

    this.addCatalogInterfaceField = function () {
        $scope.data.catalogInterfaceFields.push({});
    };

    this.removeCatalogInterfaceField = function (index) {
        $scope.data.catalogInterfaceFields.splice(index, 1);
    };

    this.denyCheckedOutCatalog = function (ev) {
        var deny = $mdDialog.confirm()
            .title($scope.trns.discard)
            .textContent($scope.trns.discardChanges)
            .ariaLabel('denyCatalog')
            .targetEvent(ev)
            .ok($scope.trns.discard)
            .cancel($scope.trns.abort);

        $mdDialog.show(deny).then(function () {
            dataGen.postAsForm($scope, {catId: $scope.data.id}, '/catalog/deny/checkedoutcatalog');
            BackService.back();
        }, function () {
        });
    };

    this.replaceCatOnApprovalProcess = function (event) {
        CatalogActionsService.replaceOnApprovalProcess(event, $scope.data.id, $scope.trns);
    };

    this.replaceCatOnOwnEdit = function (event) {
        CatalogActionsService.replaceOnOwnEdit(event, $scope.data.id, $scope.trns);
    };

    this.forceNewCheckout = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/catalog/forcenewcheckout").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.checkoutSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.checkoutCatOnApprovalProcess = function () {
        WarningService.showWarningDialog(ctrl.forceNewCheckout, null, TranslationService.get("warning"), TranslationService.get("forward"),
            TranslationService.get("abort"), [$scope.trns.catalogInApprovalCheckout]);
    };

    this.checkoutCatOnOwnEdit = function () {
        WarningService.showWarningDialog(ctrl.forceNewCheckout, null, TranslationService.get("warning"), TranslationService.get("forward"),
            TranslationService.get("abort"), [$scope.trns.catalogInOwnEditCheckout]);
    };

    this.getQualityManagementLink = function () {
        return "catalogqualitymanagement/" + $scope.data.id;
    };

    this.approveTechnical = function (event) {
        CatApprovalService.approveCatalogs([$scope.data.approvalDetailData.atiId], ctrl.redirectToCatList, event);
    };

    this.approveProfessional = function (event) {
        CatApprovalService.approveCatalogs([$scope.data.approvalDetailData.atiId], ctrl.redirectToCatList, event);
    };

    this.canApproveTechnical = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayApproveTechnical");
    };
    this.canApproveProfessional = function () {
        return !impactX.isDefined($scope, "data.approvalDetailData.hadCheckError") &&
            impactX.isDefined($scope, "data.approvalDetailData.mayApproveProfessional");
    };


    this.denyApproval = function () {
        CatApprovalService.denyCatalogs([$scope.data.approvalDetailData.atiId], ctrl.redirectToCatList);
    };
    this.canDenyApproval = function () {
        return ctrl.canApproveTechnical() || ctrl.canApproveProfessional();
    };

    this.checkInAndMoveForward = function () {
        CatApprovalService.checkInAndForwardToApproval($scope.data.id, ctrl.redirectToCatalogList, ctrl.redirectToCatalogList);
    };

    this.redirectToCatalogList = function () {
        $redirect.redirectTo(null, "cataloglist");
    };

    this.createMissingExternalProIds = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/catalog/createmissingexternalproids").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.canAccessShopView = function () {
        return impactX.isDefined($scope, "data.canAccessShopView");
    };

    ctrl.activateShopView = function () {
        ShopViewService.activateShopView({id: $scope.data.vcatId});
    };

    ctrl.getReviewLink = function () {
        return "checkedoutcataloglist/" + $scope.data.id;
    };

    ctrl.redirectToCatList = function () {
        $redirect.redirectTo(null, "/cataloglist");
    };

    ctrl.canRunChangeProtocol = function() {
        return $scope.data && $scope.data.changeProtocol && $scope.data.changeProtocol.canRunChangeProtocol;
    };

    ctrl.changeProtocolDialog = function(event) {
        CatalogActionsService.runChangeProtocolDialog(event, $scope.data.id)
    };

    ctrl.convertToExternalCatalog = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm({}, {catId: $scope.data.id}, "/catalog/changeinternalexternal").then(function () {
            $redirect.redirectTo(null, "externalcatalog/" + $scope.data.id);
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.canConvertToExternalCatalog = function () {
        return $scope.data.allowExternalCatalogConversion && !$scope.data.isInCheckoutOrRelease;
    };

    function hasErrors() {
        return ctrl.errorList.length || missingCatalogManagers();
    }

    function missingCatalogManagers() {
        if ($scope.data.requireCatalogManager) {
            return $scope.data.catalogManager.relation.assigned.length < 1 && $scope.data.catalogManagerGroup.relation.assigned.length < 1
        }
        return false;
    }

    function getErrors() {
        var errors = [].concat(ctrl.errorList);
        if (missingCatalogManagers()) {
            errors.push($scope.trns.missingCatalogmanager);
        }
        return errors;
    }

    this.initToolbarButtons = function () {
        $scope.buttonDefinition = [
            {
                label: $scope.trns.save, action: ctrl.save, type: 'validation', condition: function () {
                    return !$scope.data.isInCheckoutOrRelease
                },
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.delete, action: ctrl.deleteDialog, type: 'dialogaction', condition: function () {
                    return (!$scope.data.isInCheckoutOrRelease && $scope.data.canDelete && $scope.data.id > 0)
                }
            },
            {
                label: $scope.trns.qualityManagement,
                linkFunction: ctrl.getQualityManagementLink,
                condition: function () {
                    return $scope.data.id > 0
                },
                type: 'link',
                process: 'Catalog'
            },
            {
                label: $scope.trns.update,
                action: ctrl.redirectToSupplierCatalogUpload,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplace
                }
            },
            {
                label: $scope.trns.update,
                action: ctrl.replaceCatOnApprovalProcess,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnApprovalProcess
                }
            },
            {
                label: $scope.trns.update,
                action: ctrl.replaceCatOnOwnEdit,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnOwnEdit
                }
            },
            {
                label: $scope.trns.checkout,
                linkFunction: ctrl.getReviewLink,
                type: 'link',
                condition: function () {
                    return $scope.data.canReview;
                }
            },
            {
                label: $scope.trns.checkout,
                action: ctrl.checkoutDialog,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canCheckout
                }
            },
            {
                label: $scope.trns.checkin,
                action: ctrl.checkIn,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canCheckIn
                }
            },
            {
                label: $scope.trns.discard,
                action: ctrl.deny,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canDeny && !$scope.data.canReview && !ctrl.canDenyApproval()
                }
            },
            {
                label: $scope.trns.discard,
                action: ctrl.denyCheckedOutCatalog,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReview && !ctrl.canDenyApproval()
                }
            },
            {
                label: $scope.trns.discard, action: ctrl.delete, type: 'dialogaction', condition: function () {
                    return $scope.data.canDiscardFailedImport && !$scope.data.canDeny && !$scope.data.canDelete && !$scope.data.canReview && !ctrl.canDenyApproval()
                }
            },
            {
                label: $scope.trns.doneForward, action: ctrl.doneForward, type: 'dialogaction', condition: function () {
                    return $scope.data.canDoneForward
                }
            },
            {
                label: $scope.trns.doneForward,
                action: ctrl.checkInAndMoveForward,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canCheckinAndMoveForward
                }
            },
            {
                label: $scope.trns.approve,
                action: ctrl.approveProfessional,
                type: 'dialogaction',
                condition: ctrl.canApproveProfessional
            },
            {
                label: $scope.trns.approve,
                action: ctrl.approveTechnical,
                type: 'dialogaction',
                condition: ctrl.canApproveTechnical
            },
            {
                label: $scope.trns.deny,
                action: ctrl.denyTechnical,
                type: 'dialogaction',
                condition: ctrl.canDenyApproval
            },
            {
                label: $scope.trns.stop, action: ctrl.stop, type: 'dialogaction', condition: function () {
                    return $scope.data.canStop
                }
            },
            {
                label: $scope.trns.newCheckout,
                action: ctrl.checkoutCatOnApprovalProcess,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnApprovalProcess && !$scope.data.canCheckout
                }
            },
            {
                label: $scope.trns.newCheckout,
                action: ctrl.checkoutCatOnOwnEdit,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnOwnEdit && !$scope.data.canCheckout
                }
            },
            {
                label: $scope.trns.shopView,
                action: ctrl.activateShopView,
                type: 'dialogaction',
                condition: ctrl.canAccessShopView,
                process: 'Search'
            },
            {
                label: $scope.trns.extendLastDate,
                action: ctrl.extendLastDate,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canExtendLastDate
                }
            },
            {
                label: $scope.trns.setFixDeliveryDate,
                action: ctrl.setFixDeliveryDate,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.assignDefaultPicture,
                action: ctrl.openDefaultPictureDialog,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canAssignDefaultPicture
                }
            },
            {
                label: $scope.trns.createMissingExternalProIds,
                action: ctrl.createMissingExternalProIds,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canCreateMissingExternalProId
                }
            },
            {
                label: $scope.trns.changeProtocol,
                action: ctrl.changeProtocolDialog,
                condition: ctrl.canRunChangeProtocol,
                process: 'CatalogRunChangeRules'
            },
            {
                label: $scope.trns.convertToExternalCatalog,
                action: ctrl.convertToExternalCatalog,
                condition: ctrl.canConvertToExternalCatalog,
                process: 'Catalog'
            }
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    this.redirectToSupplierCatalogUpload = function () {
        $redirect.redirectTo(null, "/suppliercatalogupload/" + $scope.data.id);
    };

    this.openCatalogContractRelationDialog = function (event) {
        var catalogContractDialogSetting = {
            controller: 'CatalogContractDialogController',
            controllerAs: 'catalogContractDialogController',
            templateUrl: 'modules/catalog/templates/catalog-contract-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                catId: $scope.data.id,
            }
        };
        $mdDialog.show(catalogContractDialogSetting);
    };

    this.changeMatchCodeValue = function (matchCode, newValue) {
        if (!newValue) {
            matchCode.secondValue = false;
        }
    };

    this.openDefaultPictureDialog = function (event) {
        return DefaultPicture.showDefaultPictureDialog($scope.data.id, null, event)
    };

    this.onSupplierSelect = function (selected) {
        if (selected && selected.id && selected.id > 0 && $scope.data.id == 0)
        {
            dataGen.getData({}, {supplierId: selected.id}, "/catalog/matchcodedata").then(function (data) {
                $scope.data.matchCodeSettings = data.data.matchCodeSettings;
            });
        }
        else
        {
            $scope.data.matchCodeSettings = null;
        }
    };
}
